module.exports = __webpack_public_path__ + "static/media/logo.e3f2f38e.PNG";